import { gql } from "@apollo/client";

export const removeLibraryVideo = gql`
  mutation removeLibraryVideo($_id: MongoID!) {
    libraryVideo_RemoveById(_id :$_id) {
      record {
        _id
      }
    }
  }
`;